/**
 * This file was auto-generated by @openapi-qraft/cli.
 * Do not make direct changes to the file.
 */

import type {
  DeepReadonly,
  InvalidateQueryFilters,
  OperationError,
  OperationInfiniteData,
  PartialParameters,
  QraftServiceOperationsToken,
  QueryFiltersByParameters,
  QueryFiltersByQueryKey,
  QueryFnOptionsByParameters,
  QueryFnOptionsByQueryKey,
  RequestFnResponse,
  ServiceOperationEnsureInfiniteQueryDataOptions,
  ServiceOperationEnsureQueryDataOptions,
  ServiceOperationFetchInfiniteQueryOptions,
  ServiceOperationFetchQueryOptions,
  ServiceOperationInfiniteQueryKey,
  ServiceOperationQueryKey,
  UseQueryOptionsForUseQueries,
  UseQueryOptionsForUseSuspenseQuery,
  WithOptional,
} from '@openapi-qraft/tanstack-query-react-types';
import type {
  CancelOptions,
  DefinedInitialDataInfiniteOptions,
  DefinedInitialDataOptions,
  DefinedUseInfiniteQueryResult,
  DefinedUseQueryResult,
  InfiniteQueryPageParamsOptions,
  InvalidateOptions,
  NoInfer,
  QueryState,
  RefetchOptions,
  ResetOptions,
  SetDataOptions,
  UndefinedInitialDataInfiniteOptions,
  UndefinedInitialDataOptions,
  Updater,
  UseInfiniteQueryResult,
  UseQueryResult,
  UseSuspenseInfiniteQueryOptions,
  UseSuspenseInfiniteQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult,
} from '@tanstack/react-query';

import type { paths } from '../schema';

export interface DocumentsService {
  /** @summary Get Document */
  getDocument: {
    /** @summary Get Document */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options:
        | QueryFnOptionsByQueryKey<GetDocumentSchema, GetDocumentParameters, TMeta, TSignal>
        | QueryFnOptionsByParameters<GetDocumentParameters, TMeta, TSignal>,
      client?: (
        schema: GetDocumentSchema,
        options: {
          parameters: GetDocumentParameters;
          signal?: TSignal;
          meta?: TMeta;
        }
      ) => Promise<RequestFnResponse<GetDocumentData, GetDocumentError>>
    ): Promise<RequestFnResponse<GetDocumentData, GetDocumentError>>;
    /** @summary Get Document */
    getQueryKey(
      parameters: DeepReadonly<GetDocumentParameters>
    ): ServiceOperationQueryKey<GetDocumentSchema, GetDocumentParameters>;
    /**
     * Performs asynchronous data fetching, manages loading states and error handling.
     *
     * @summary Get Document
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
     * @example Query with parameters
     * ```ts
     * const { data, isLoading } = qraft.documentsService.getDocument.useQuery({
     *     path: {
     *         document_id: documentId
     *     },
     *     query: {
     *         expires_in: expiresIn
     *     }
     * })
     * ```
     */
    useQuery<TData = GetDocumentData>(
      parameters:
        | ServiceOperationQueryKey<GetDocumentSchema, GetDocumentParameters>
        | DeepReadonly<GetDocumentParameters>,
      options?: Omit<
        UndefinedInitialDataOptions<
          GetDocumentData,
          GetDocumentError,
          TData,
          ServiceOperationQueryKey<GetDocumentSchema, GetDocumentParameters>
        >,
        'queryKey'
      >
    ): UseQueryResult<TData, OperationError<GetDocumentError>>;
    /**
     * Performs asynchronous data fetching, manages loading states and error handling.
     *
     * @summary Get Document
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
     * @example Query with parameters
     * ```ts
     * const { data, isLoading } = qraft.documentsService.getDocument.useQuery({
     *     path: {
     *         document_id: documentId
     *     },
     *     query: {
     *         expires_in: expiresIn
     *     }
     * })
     * ```
     */
    useQuery<TData = GetDocumentData>(
      parameters:
        | ServiceOperationQueryKey<GetDocumentSchema, GetDocumentParameters>
        | DeepReadonly<GetDocumentParameters>,
      options: Omit<
        DefinedInitialDataOptions<
          GetDocumentData,
          GetDocumentError,
          TData,
          ServiceOperationQueryKey<GetDocumentSchema, GetDocumentParameters>
        >,
        'queryKey'
      >
    ): DefinedUseQueryResult<TData, OperationError<GetDocumentError>>;
    /** @summary Get Document */
    getInfiniteQueryKey(
      parameters: DeepReadonly<GetDocumentParameters>
    ): ServiceOperationInfiniteQueryKey<GetDocumentSchema, GetDocumentParameters>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     *
     * @summary Get Document
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
     *
     * @example Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.documentsService.getDocument.useInfiniteQuery({
     *     path: {
     *         document_id: documentId
     *     }
     * }, {
     *     initialPageParam: {
     *         query: {
     *             expires_in: initialExpiresIn
     *         }
     *     },
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useInfiniteQuery<
      TPageParam extends GetDocumentParameters,
      TQueryFnData = GetDocumentData,
      TData = OperationInfiniteData<TQueryFnData, GetDocumentParameters>,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<GetDocumentSchema, GetDocumentParameters>
        | DeepReadonly<GetDocumentParameters>,
      options: Omit<
        UndefinedInitialDataInfiniteOptions<
          TQueryFnData,
          GetDocumentError,
          TData,
          ServiceOperationInfiniteQueryKey<GetDocumentSchema, GetDocumentParameters>,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>
    ): UseInfiniteQueryResult<TData, OperationError<GetDocumentError>>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     *
     * @summary Get Document
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
     *
     * @example Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.documentsService.getDocument.useInfiniteQuery({
     *     path: {
     *         document_id: documentId
     *     }
     * }, {
     *     initialPageParam: {
     *         query: {
     *             expires_in: initialExpiresIn
     *         }
     *     },
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useInfiniteQuery<
      TPageParam extends GetDocumentParameters,
      TQueryFnData = GetDocumentData,
      TData = OperationInfiniteData<TQueryFnData, GetDocumentParameters>,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<GetDocumentSchema, GetDocumentParameters>
        | DeepReadonly<GetDocumentParameters>,
      options: Omit<
        DefinedInitialDataInfiniteOptions<
          TQueryFnData,
          GetDocumentError,
          TData,
          ServiceOperationInfiniteQueryKey<GetDocumentSchema, GetDocumentParameters>,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<GetDocumentData, PartialParameters<DeepReadonly<TPageParam>>>
    ): DefinedUseInfiniteQueryResult<TData, OperationError<GetDocumentError>>;
    /**
     * Monitors the number of queries currently fetching, matching the provided filters.
     * Useful for creating loading indicators or performing actions based on active requests.
     *
     * @summary Get Document
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
     * @example Checks the total number of queries fetching from the specified service method,
     * both normal and infinite. If no parameters are provided, no filtering is applied.
     * ```ts
     * const getDocumentTotal = qraft.documentsService.getDocument.useIsFetching()
     * ```
     * @example Checks the number of normal queries fetching with the specified parameters.
     * ```ts
     * const getDocumentByParametersTotal = qraft.documentsService.getDocument.useIsFetching({
     *     infinite: false,
     *     parameters: {
     *         path: {
     *             document_id: documentId
     *         },
     *         query: {
     *             expires_in: expiresIn
     *         }
     *     }
     * })
     * ```
     */
    useIsFetching<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetDocumentSchema,
            GetDocumentData,
            TInfinite,
            GetDocumentParameters,
            GetDocumentError
          >
        | QueryFiltersByQueryKey<GetDocumentSchema, GetDocumentData, TInfinite, GetDocumentParameters, GetDocumentError>
    ): number;
    /**
     * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
     *
     * @summary Get Document
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
     * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
     * ```ts
     * const getDocumentResults = qraft.documentsService.getDocument.useQueries({
     *     queries: [
     *         {
     *             path: {
     *                 document_id: documentId1
     *             },
     *             query: {
     *                 expires_in: expiresIn1
     *             }
     *         },
     *         {
     *             path: {
     *                 document_id: documentId2
     *             },
     *             query: {
     *                 expires_in: expiresIn2
     *             }
     *         }
     *     ]
     * });
     * getDocumentResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
     * ```
     * @example Combined results. Only the data will be returned.
     * ```ts
     * const getDocumentCombinedResults = qraft.documentsService.getDocument.useQueries({
     *     combine: results => results.map(result => result.data),
     *     queries: [
     *         {
     *             path: {
     *                 document_id: documentId1
     *             },
     *             query: {
     *                 expires_in: expiresIn1
     *             }
     *         },
     *         {
     *             path: {
     *                 document_id: documentId2
     *             },
     *             query: {
     *                 expires_in: expiresIn2
     *             }
     *         }
     *     ]
     * });
     * getDocumentCombinedResults.forEach(data => console.log({ data }));
     * ```
     */
    useQueries<
      T extends Array<
        UseQueryOptionsForUseQueries<GetDocumentSchema, GetDocumentParameters, GetDocumentData, GetDocumentError>
      >,
      TCombinedResult = Array<UseQueryResult<GetDocumentData, GetDocumentError>>,
    >(options: {
      queries: T;
      combine?: (results: Array<UseQueryResult<GetDocumentData, GetDocumentError>>) => TCombinedResult;
    }): TCombinedResult;
    /**
     * Performs asynchronous data fetching with Suspense support.
     * Similar to useQuery but integrates with React Suspense for loading states.
     *
     * @summary Get Document
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
     * @example Suspense Query with parameters
     * ```ts
     * const data = qraft.documentsService.getDocument.useSuspenseQuery({
     *     path: {
     *         document_id: documentId
     *     },
     *     query: {
     *         expires_in: expiresIn
     *     }
     * })
     * ```
     */
    useSuspenseQuery<TData = GetDocumentData>(
      parameters:
        | ServiceOperationQueryKey<GetDocumentSchema, GetDocumentParameters>
        | DeepReadonly<GetDocumentParameters>,
      options?: Omit<
        UseSuspenseQueryOptions<
          GetDocumentData,
          GetDocumentError,
          TData,
          ServiceOperationQueryKey<GetDocumentSchema, GetDocumentParameters>
        >,
        'queryKey'
      >
    ): UseSuspenseQueryResult<TData, OperationError<GetDocumentError>>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
     *
     * @summary Get Document
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
     *
     * @example Suspense Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.documentsService.getDocument.useSuspenseInfiniteQuery({
     *     path: {
     *         document_id: documentId
     *     }
     * }, {
     *     initialPageParam: {
     *         query: {
     *             expires_in: initialExpiresIn
     *         }
     *     },
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useSuspenseInfiniteQuery<TPageParam extends GetDocumentParameters, TData = GetDocumentData>(
      parameters:
        | ServiceOperationInfiniteQueryKey<GetDocumentSchema, GetDocumentParameters>
        | DeepReadonly<GetDocumentParameters>,
      options: Omit<
        UseSuspenseInfiniteQueryOptions<
          GetDocumentData,
          GetDocumentError,
          OperationInfiniteData<TData, GetDocumentParameters>,
          ServiceOperationInfiniteQueryKey<GetDocumentSchema, GetDocumentParameters>,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<GetDocumentData, PartialParameters<DeepReadonly<TPageParam>>>
    ): UseSuspenseInfiniteQueryResult<
      OperationInfiniteData<TData, GetDocumentParameters>,
      OperationError<GetDocumentError>
    >;
    /**
     * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
     * Similar to useQueries but integrates with React Suspense for loading states.
     *
     * @summary Get Document
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
     * @example Basic usage with Suspense
     * ```ts
     * const getDocumentData = qraft.documentsService.getDocument.useSuspenseQueries({
     *     queries: [
     *         {
     *             path: {
     *                 document_id: documentId1
     *             },
     *             query: {
     *                 expires_in: expiresIn1
     *             }
     *         },
     *         {
     *             path: {
     *                 document_id: documentId2
     *             },
     *             query: {
     *                 expires_in: expiresIn2
     *             }
     *         }
     *     ]
     * });
     * getDocumentResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
     * ```
     * @example With data transformation using combine
     * ```ts
     * const getDocumentCombinedData = qraft.documentsService.getDocument.useSuspenseQueries({
     *     combine: results => results.map(result => result.data),
     *     queries: [
     *         {
     *             path: {
     *                 document_id: documentId1
     *             },
     *             query: {
     *                 expires_in: expiresIn1
     *             }
     *         },
     *         {
     *             path: {
     *                 document_id: documentId2
     *             },
     *             query: {
     *                 expires_in: expiresIn2
     *             }
     *         }
     *     ]
     * });
     * getDocumentCombinedData.forEach(data => console.log({ data }));
     * ```
     */
    useSuspenseQueries<
      T extends Array<
        UseQueryOptionsForUseSuspenseQuery<GetDocumentSchema, GetDocumentParameters, GetDocumentData, GetDocumentError>
      >,
      TCombinedResult = Array<UseSuspenseQueryResult<GetDocumentData, GetDocumentError>>,
    >(options: {
      queries: T;
      combine?: (
        results: Array<WithOptional<UseSuspenseQueryResult<GetDocumentData, GetDocumentError>, 'data'>>
      ) => TCombinedResult;
    }): TCombinedResult;
    /** @summary Get Document */
    fetchQuery(
      options: ServiceOperationFetchQueryOptions<
        GetDocumentSchema,
        GetDocumentData,
        GetDocumentParameters,
        GetDocumentError
      >
    ): Promise<GetDocumentData>;
    /** @summary Get Document */
    prefetchQuery(
      options: ServiceOperationFetchQueryOptions<
        GetDocumentSchema,
        GetDocumentData,
        GetDocumentParameters,
        GetDocumentError
      >
    ): Promise<void>;
    /** @summary Get Document */
    ensureQueryData(
      options: ServiceOperationEnsureQueryDataOptions<
        GetDocumentSchema,
        GetDocumentData,
        GetDocumentParameters,
        GetDocumentError
      >
    ): Promise<GetDocumentData>;
    /** @summary Get Document */
    fetchInfiniteQuery<TPageParam extends GetDocumentParameters>(
      options: ServiceOperationFetchInfiniteQueryOptions<
        GetDocumentSchema,
        GetDocumentData,
        GetDocumentParameters,
        DeepReadonly<TPageParam>,
        GetDocumentError
      >
    ): Promise<OperationInfiniteData<GetDocumentData, GetDocumentParameters>>;
    /** @summary Get Document */
    prefetchInfiniteQuery<TPageParam extends GetDocumentParameters>(
      options: ServiceOperationFetchInfiniteQueryOptions<
        GetDocumentSchema,
        GetDocumentData,
        GetDocumentParameters,
        DeepReadonly<TPageParam>,
        GetDocumentError
      >
    ): Promise<void>;
    /** @summary Get Document */
    ensureInfiniteQueryData<TPageParam extends GetDocumentParameters>(
      options: ServiceOperationEnsureInfiniteQueryDataOptions<
        GetDocumentSchema,
        GetDocumentData,
        GetDocumentParameters,
        DeepReadonly<TPageParam>,
        GetDocumentError
      >
    ): Promise<OperationInfiniteData<GetDocumentData, GetDocumentParameters>>;
    /** @summary Get Document */
    getQueryData(
      parameters:
        | ServiceOperationQueryKey<GetDocumentSchema, GetDocumentParameters>
        | DeepReadonly<GetDocumentParameters>
    ): GetDocumentData | undefined;
    /** @summary Get Document */
    getInfiniteQueryData(
      parameters:
        | ServiceOperationInfiniteQueryKey<GetDocumentSchema, GetDocumentParameters>
        | DeepReadonly<GetDocumentParameters>
    ): OperationInfiniteData<GetDocumentData, GetDocumentParameters> | undefined;
    /** @summary Get Document */
    getQueriesData<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetDocumentSchema,
            GetDocumentData,
            TInfinite,
            GetDocumentParameters,
            GetDocumentError
          >
        | QueryFiltersByQueryKey<GetDocumentSchema, GetDocumentData, TInfinite, GetDocumentParameters, GetDocumentError>
    ): TInfinite extends true
      ? Array<
          [
            queryKey: ServiceOperationInfiniteQueryKey<GetDocumentSchema, GetDocumentParameters>,
            data: NoInfer<OperationInfiniteData<GetDocumentData, GetDocumentParameters>> | undefined,
          ]
        >
      : Array<
          [
            queryKey: ServiceOperationQueryKey<GetDocumentSchema, GetDocumentParameters>,
            data: GetDocumentData | undefined,
          ]
        >;
    /** @summary Get Document */
    getQueryState(
      parameters:
        | ServiceOperationQueryKey<GetDocumentSchema, GetDocumentParameters>
        | DeepReadonly<GetDocumentParameters>
    ): QueryState<GetDocumentData, GetDocumentError> | undefined;
    /** @summary Get Document */
    getInfiniteQueryState(
      parameters:
        | DeepReadonly<GetDocumentParameters>
        | ServiceOperationInfiniteQueryKey<GetDocumentSchema, GetDocumentParameters>
    ): QueryState<OperationInfiniteData<GetDocumentData, GetDocumentParameters>, GetDocumentError> | undefined;
    /** @summary Get Document */
    setQueryData(
      parameters:
        | DeepReadonly<GetDocumentParameters>
        | ServiceOperationQueryKey<GetDocumentSchema, GetDocumentParameters>,
      updater: Updater<NoInfer<GetDocumentData> | undefined, NoInfer<DeepReadonly<GetDocumentData>> | undefined>,
      options?: SetDataOptions
    ): GetDocumentData | undefined;
    /** @summary Get Document */
    setInfiniteQueryData(
      parameters:
        | DeepReadonly<GetDocumentParameters>
        | ServiceOperationInfiniteQueryKey<GetDocumentSchema, GetDocumentParameters>,
      updater: Updater<
        NoInfer<OperationInfiniteData<GetDocumentData, GetDocumentParameters>> | undefined,
        NoInfer<DeepReadonly<OperationInfiniteData<GetDocumentData, GetDocumentParameters>>> | undefined
      >,
      options?: SetDataOptions
    ): OperationInfiniteData<GetDocumentData, GetDocumentParameters> | undefined;
    /** @summary Get Document */
    setQueriesData<TInfinite extends boolean = false>(
      filters:
        | QueryFiltersByParameters<
            GetDocumentSchema,
            GetDocumentData,
            TInfinite,
            GetDocumentParameters,
            GetDocumentError
          >
        | QueryFiltersByQueryKey<
            GetDocumentSchema,
            GetDocumentData,
            TInfinite,
            GetDocumentParameters,
            GetDocumentError
          >,
      updater: Updater<NoInfer<GetDocumentData> | undefined, NoInfer<GetDocumentData> | undefined>,
      options?: SetDataOptions
    ): Array<GetDocumentData | undefined>;
    /** @summary Get Document */
    invalidateQueries<TInfinite extends boolean = false>(
      filters?: InvalidateQueryFilters<
        GetDocumentSchema,
        GetDocumentData,
        TInfinite,
        GetDocumentParameters,
        GetDocumentError
      >,
      options?: InvalidateOptions
    ): Promise<void>;
    /** @summary Get Document */
    refetchQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetDocumentSchema,
            GetDocumentData,
            TInfinite,
            GetDocumentParameters,
            GetDocumentError
          >
        | QueryFiltersByQueryKey<
            GetDocumentSchema,
            GetDocumentData,
            TInfinite,
            GetDocumentParameters,
            GetDocumentError
          >,
      options?: RefetchOptions
    ): Promise<void>;
    /** @summary Get Document */
    cancelQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetDocumentSchema,
            GetDocumentData,
            TInfinite,
            GetDocumentParameters,
            GetDocumentError
          >
        | QueryFiltersByQueryKey<
            GetDocumentSchema,
            GetDocumentData,
            TInfinite,
            GetDocumentParameters,
            GetDocumentError
          >,
      options?: CancelOptions
    ): Promise<void>;
    /** @summary Get Document */
    removeQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetDocumentSchema,
            GetDocumentData,
            TInfinite,
            GetDocumentParameters,
            GetDocumentError
          >
        | QueryFiltersByQueryKey<GetDocumentSchema, GetDocumentData, TInfinite, GetDocumentParameters, GetDocumentError>
    ): void;
    /** @summary Get Document */
    resetQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetDocumentSchema,
            GetDocumentData,
            TInfinite,
            GetDocumentParameters,
            GetDocumentError
          >
        | QueryFiltersByQueryKey<
            GetDocumentSchema,
            GetDocumentData,
            TInfinite,
            GetDocumentParameters,
            GetDocumentError
          >,
      options?: ResetOptions
    ): Promise<void>;
    /** @summary Get Document */
    isFetching<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetDocumentSchema,
            GetDocumentData,
            TInfinite,
            GetDocumentParameters,
            GetDocumentError
          >
        | QueryFiltersByQueryKey<GetDocumentSchema, GetDocumentData, TInfinite, GetDocumentParameters, GetDocumentError>
    ): number;
    schema: GetDocumentSchema;
    types: {
      parameters: GetDocumentParameters;
      data: GetDocumentData;
      error: GetDocumentError;
    };
  };
}
/** @summary Get Document */
export const getDocument = {
  schema: {
    method: 'get',
    url: '/documents/{document_id}',
    security: ['HTTPBearer'],
  },
} as {
  schema: GetDocumentSchema;
  [QraftServiceOperationsToken]: DocumentsService['getDocument'];
};
export const documentsService = {
  getDocument,
} as const;
type GetDocumentSchema = {
  method: 'get';
  url: '/documents/{document_id}';
  security: ['HTTPBearer'];
};
type GetDocumentParameters = paths['/documents/{document_id}']['get']['parameters'];
type GetDocumentData = paths['/documents/{document_id}']['get']['responses']['200']['content']['application/json'];
type GetDocumentError = paths['/documents/{document_id}']['get']['responses']['422']['content']['application/json'];
